import { SERVICES_AN_ERROR_OCCURRED_LOADING } from 'common/constants/services/services';
import { FIRM_SUMMARY_MEASUREMENT_DATES_TITLE, FIRM_SUMMARY_TITLE } from 'pages/Firms/common/constants';

export const SERVICES_FIRMS_REFETCH_ON_WINDOW_FOCUS = false;

// Firm Tasks Progress
export const TASKS_PROGRESS_BY_FIRM_QUERY_KEY = 'TASKS_PROGRESS_BY_FIRM';
export const TASKS_PROGRESS_BY_FIRM_TITLE = 'Firm Tasks Progress';
export const TASKS_PROGRESS_BY_FIRM_DEFAULT_ERROR_MESSAGE =
  SERVICES_AN_ERROR_OCCURRED_LOADING(TASKS_PROGRESS_BY_FIRM_TITLE);

// Firm Task Progress Details
export const TASK_PROGRESS_DETAILS_QUERY_KEY = 'TASK_PROGRESS_DETAILS';
export const TASK_PROGRESS_DETAILS_TITLE = 'Firm Tasks Progress';
export const TASK_PROGRESS_DETAILS_DEFAULT_ERROR_MESSAGE =
  SERVICES_AN_ERROR_OCCURRED_LOADING(TASK_PROGRESS_DETAILS_TITLE);

// Measurement dates by firm
export const MEASUREMENT_DATES_BY_FIRM_QUERY_KEY = 'MEASUREMENT_DATES_BY_FIRM';
export const MEASUREMENT_DATES_BY_FIRM_TITLE = FIRM_SUMMARY_MEASUREMENT_DATES_TITLE;
export const MEASUREMENT_DATES_BY_FIRM_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(
  MEASUREMENT_DATES_BY_FIRM_TITLE
);

// Firm summary
export const FIRM_SUMMARY_QUERY_KEY = 'FIRM_SUMMARY';
export const FIRM_SUMMARY_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(FIRM_SUMMARY_TITLE);

// Firm summary definition data
export const FIRM_SUMMARY_DEFINITION_DATA_QUERY_KEY = 'FIRM_SUMMARY_DEFINITION_DATA';
export const FIRM_SUMMARY_DEFINITION_DATA_STALE_TIME = 5 * 60 * 1000; // 5 min — data only changes on explicit save
export const FIRM_SUMMARY_DEFINITION_DATA_TITLE = 'Firm Summary Definition Data';
export const FIRM_SUMMARY_DEFINITION_DATA_DEFAULT_ERROR_MESSAGE = SERVICES_AN_ERROR_OCCURRED_LOADING(
  FIRM_SUMMARY_DEFINITION_DATA_TITLE
);
